<template>
  <div class="iframe-container">
    <iframe
      v-if="iframeSrc"
      ref="iframe"
      :src="iframeSrc"
      class="full-height-iframe"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";

export default {
  name: "DigitalReport",
  data() {
    return {
      company: "",
      country: "",
      iframeSrc: "",
      orderId: "",
      heartbeatInterval: null,
      heartbeatFailures: 0,
      maxHeartbeatFailures: 3,
    };
  },
  mounted() {
    this.extractParams();
    window.addEventListener("message", this.handleMessage);
    this.startHeartbeat();
  },
  beforeUnmount() {
    this.cleanupHeartbeat();
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    extractParams() {
      const pathSegments = window.location.pathname.split("/").filter(Boolean);
      const queryParams = new URLSearchParams(window.location.search);
      const sampleReportTypeQyery=queryParams.get("reportType")
      if (pathSegments.length >= 3 && pathSegments[0] === "digital-report") {
        this.company = decodeURIComponent(pathSegments[1]);
        this.country = decodeURIComponent(pathSegments[2]);
        this.orderId = decodeURIComponent(pathSegments[3]);
        const rawSource = "credenceSearch";
        const source = btoa(rawSource);
        this.iframeSrc = `${process.env.VUE_APP_MASTER_APP_URL
        }company-dashboard/${encodeURIComponent(
          this.company
        )}/${encodeURIComponent(
          this.country
        )}?nocache=${Date.now()}&source=${source}&reportType=${sampleReportTypeQyery}`;

        // Wait for iframe to load, then send token
        this.$nextTick(() => {
          this.sendTokenToIframe();
        });
      }
    },
    startHeartbeat() {
      this.heartbeatInterval = setInterval(() => {
        const iframe = this.$refs.iframe;
        if (iframe && iframe.contentWindow) {
          if (this.heartbeatFailures >= this.maxHeartbeatFailures) {
            this.recoverConnection();
            return;
          }

          iframe.contentWindow.postMessage(
            {
              type: "HEARTBEAT",
              timestamp: Date.now(),
            },
            "*"
          );

          this.heartbeatFailures++;

          // Set timeout to check if we got a response
          setTimeout(() => {
            if (this.heartbeatFailures >= this.maxHeartbeatFailures) {
              this.recoverConnection();
            }
          }, 2000);
        }
      }, 10000);
    },
    cleanupHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },

    recoverConnection() {
      this.cleanupHeartbeat();
      console.warn("Connection lost, attempting recovery...");
      this.sendTokenToIframe();
      setTimeout(() => {
        this.heartbeatFailures = 0;
        this.startHeartbeat();
      }, 3000);
    },
    getTokenFromCookies() {
      return VueCookies.get("token"); // Get token from VueCookies
    },
    sendTokenToIframe() {
      const iframe = this.$refs.iframe;
      if (iframe && iframe.contentWindow) {
        const token = this.getTokenFromCookies();
        if (token) {
          const message = {
            type: "AUTH_DATA",
            email: VueCookies.get("email"),
            token: token,
            orderId: this.orderId,
            source: "credenceSearch",
          };

          try {
            iframe.contentWindow.postMessage(message, "*");
            console.debug("Auth data sent to iframe");
          } catch (error) {
            console.error("Failed to send auth data to iframe:", error);
          }
        }
      }
    },

    handleMessage(event) {
      const iframe = this.$refs.iframe;

      // Verify the message is from our iframe
      if (!iframe || event.source !== iframe.contentWindow) {
        return;
      }

      switch (event.data?.type) {
        case "IFRAME_READY":
        case "REQUEST_AUTH":
          this.sendTokenToIframe();
          break;

        case "HEARTBEAT_RESPONSE":
          this.heartbeatFailures = 0;
          console.debug("Heartbeat response received");
          break;

        case "DATA_LOADED":
          // Stop heartbeat when data is confirmed loaded
          this.cleanupHeartbeat();
          break;

        case "ERROR_LOGOUT":
          this.cleanupHeartbeat();
          this.$store.dispatch("processLogout");
          break;

        case "ERROR_NOT_ACCESSIBLE":
          this.cleanupHeartbeat();
          alert("This order is not accessible.\n\nYou may not have the required permissions or the order might no longer be available.");
          window.close();
          break;
      }
    },
  },
};
</script>
<style scoped>
.iframe-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.full-height-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
